<template>
  <div>
    <div>
      <TopNavbar title="基友秀" :rightText="postLoading?'发布中':'发布'" @clickRight="onClickPost"></TopNavbar>
      <div class="create-container">
        <Field
            v-model="description"
            rows="1"
            :autosize="{minHeight: 100, maxHeight:150}"
            type="textarea"
            placeholder="这里输入..."
            maxlength="2000"
        >
        </Field>
        <div class="uploader-container">
          <Uploader
              v-model="fileList"
              :after-read="onAfterRead"
              multiple
              :max-count="9"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {Field, Uploader, Toast, Button, Icon} from "vant"
  import TopNavbar from "../../common/TopNavbar";

  export default {
    name: "MomentCreateComponent",
    components: {
      TopNavbar, Icon, Field, Uploader, Toast, Button
    },
    props: {
      config: {},
      refItemId: {}
    },
    data() {
      return {
        postLoading: false,
        title: "",
        description: "",
        userInfo: {},

        autoSize: {
          minHeight: 30
        },

        fileList: [],
        fileImageUrisMap: {},
      }
    },
    async mounted() {
      if (this.config.backup_key) {
        this.loadBackupData(this.config.backup_key)
      }
    },
    beforeDestroy() {
      if (this.config.backup_key) {
        this.saveBackUpData(this.config.backup_key)
      }
    },
    methods: {
      saveBackUpData(backupKey) {
        let file_list = []
        let data = {}

        for (let i = 0; i < this.fileList.length; i++) {
          file_list.push({
            "url": this.fileList[i].url,
            "uri": this.fileList[i].uri,
          })
        }

        data = {
          title: this.title,
          description: this.description,
          file_list: file_list,
        }

        try {
          localStorage.setItem(backupKey, JSON.stringify(data))
        } catch (e) {
          console.log(e)
        }
      },

      loadBackupData(backupKey) {
        try {
          let s = localStorage.getItem(backupKey)
          if (s) {
            let data = JSON.parse(s)
            if (data.title) {
              this.title = data.title
            }
            if (data.description) {
              this.description = data.description
            }
            if (data.file_list) {
              for (let i = 0; i < data.file_list.length; i++) {
                this.fileList.push({url: data.file_list[i].url, uri: data.file_list[i].uri})
              }
            }
          }
        } catch (e) {
          console.log(e)
        }
      },

      async onClickPost() {
        let imageUris = []
        for (let i = 0; i < this.fileList.length; i++) {
          imageUris.push(this.fileList[i].uri)
        }

        if (!this.title && !this.description && (!imageUris || imageUris.length === 0)) {
          Toast("请输入内容")
          return
        }

        this.postLoading = true

        let params = {
          title: this.title,
          description: this.description,
          image_uris: imageUris,
        }

        if (this.refItemId) {
          params.ref_item_id = parseInt(this.refItemId)
        }

        if (this.config.scene) {
          params.scene = this.config.scene
        }

        await this.$store.dispatch("CreateMoment", params).then((data) => {
          if (data.code === 0) {
            Toast("发表成功")
            this.title = ""
            this.description = ""
            this.fileList = []
            this.$emit("postStatus", data.code)
          } else if (data.code === 20010) {
            this.$emit("postStatus", data.code)
          }
        }, () => {
          Toast("网络错误")
        })
        this.postLoading = false
      },

      onAfterRead(file) {
        if (Array.isArray(file)) {
          for (let i = 0; i < file.length; i ++) {
            this.onAfterReadSingleFile(file[i])
          }
        } else {
          this.onAfterReadSingleFile(file)
        }
      },

      onAfterReadSingleFile(file) {
        let params = new FormData()
        params.append('file', file.file)
        params.append("bucket", "bos-hkfile")
        params.append("source", "moment")
        file.status = "uploading"

        this.$store.dispatch("UploadImage", params).then((data) => {
          if (data.code === 0) {
            file.status = "done"
            file.uri = data.data.uri
            file.url = data.data.image_url
          } else {
            file.status = "failed"
          }
        }, () => {
          file.status = "failed"
        })
      },
    },
    watch: {},
    computed: {}
  }
</script>

<style lang="scss" scoped>
  .create-container {
  }

  .uploader-container {
    padding: 8px;
    margin-top: 10px;
  }
</style>
